import React, { useState, useEffect } from "react";
import App from "./App";
import LoadingScreen from "./components/LoadingScreen";

export default function AppRoot() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    function handleLoad() {
      // small delay so the loader is visible briefly
      setTimeout(() => setLoading(false), 900);
    }

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return loading ? <LoadingScreen /> : <App />;
}
